import { render, staticRenderFns } from "./FleetPropertiesForm.vue?vue&type=template&id=4b96b56b&"
import script from "./FleetPropertiesForm.vue?vue&type=script&lang=js&"
export * from "./FleetPropertiesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/working_dir/management-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b96b56b')) {
      api.createRecord('4b96b56b', component.options)
    } else {
      api.reload('4b96b56b', component.options)
    }
    module.hot.accept("./FleetPropertiesForm.vue?vue&type=template&id=4b96b56b&", function () {
      api.rerender('4b96b56b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Fleets/Forms/FleetPropertiesForm.vue"
export default component.exports